import { setActiveSortParameter } from "@global-state/pages/user/myProxies/slice";
import { Sorter } from "@ui";
import { useAppSelector, useAppDispatch } from "store/hooks";

export function SorterContainer() {
    const activeSortParameter = useAppSelector(state => state.myProxiesUserPage.activeSortParameter);

    const dispatch = useAppDispatch();

    return (
        <Sorter
            currentValue={activeSortParameter}
            onChange={(value) => {
                if (activeSortParameter !== value.value) {
                    dispatch(setActiveSortParameter(value.value));
                } else {
                    dispatch(setActiveSortParameter(""));
                }
            }}
            listValue={[
                {
                    label: "Термін дії",
                    value: "term"
                }
            ]}
        />
    )
}